import script from "./Home.vue?vue&type=script&setup=true&lang=js"
export * from "./Home.vue?vue&type=script&setup=true&lang=js"

import "./Home.vue?vue&type=style&index=0&id=5f51094a&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/workspace/Official-tianwen-frontend/node_modules/_vue-loader@17.0.1@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f51094a"]])

export default __exports__